<section>
  <div class="row">
    <form class="needs-validation container-style" [formGroup]="formBranch">
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="invoiceVoucherCode" [labelText]="'Cta.Factura'"
                [maxLength]="6"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="debitNoteVoucherCode" [labelText]="'Cta.Notas Déb.'"
                [maxLength]="6"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="creditNoteVoucherCode" [labelText]="'Cta.Notas Cré.'"
                [maxLength]="6"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="cashReceiptVoucherCode" [labelText]="'Cta.Rec. Caja'"
                [maxLength]="6"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="reteIvaSaleCode" [labelText]="'Cta.Vta. ReteIva'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="cxcAccount" [labelText]="'Cta.CxC'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="creeDebitAccount" [labelText]="'Cta.Deb.Cree'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="creeCreditAccount" [labelText]="'Cta.Cre.Cree'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="utilizationAccount" [labelText]="'Cta.Vr.Utilidad'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="canceledInvoiceAccount" [labelText]="'Cta.Fra.Anuladas'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="utilityIvaContractAccount" [labelText]="'Cta.Contrato Iva Util.'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="invoiceVoucherType" [labelText]="'Facturas'"
                [maxLength]="6"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="debitNoteVoucherType" [labelText]="'Notas Débito'"
                [maxLength]="6"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="creditNoteVoucherType" [labelText]="'Notas Crédito'"
                [maxLength]="6"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <app-custom-input-text formControlName="cashReceiptVoucherType" [labelText]="'Recibos Caja'"
                [maxLength]="6"></app-custom-input-text>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="row ms-lg-2">
            <div class="col-lg-12 col-md-12 col-12">
              <app-custom-textarea formControlName="devolutionObservation" [labelText]="'Observación Devolución'"
                [autoResize]="false" [rows]="branchContract.devolutionObservation  ? 3 : 1">
              </app-custom-textarea>
            </div>
            <div class="col-lg-12 col-md-12 col-12">
              <app-custom-textarea formControlName="predevolutionObservation" [labelText]="'Observación Predevolución'"
                [autoResize]="false" [rows]="branchContract.predevolutionObservation  ? 3 : 1">
              </app-custom-textarea>
            </div>
            <div class="col-lg-12 col-md-12 col-12">
              <app-custom-textarea formControlName="remissionObservation" [labelText]="'Observación Remisión'"
                [autoResize]="false" [rows]="branchContract.remissionObservation  ? 3 : 1">
              </app-custom-textarea>
            </div>
            <div class="col-lg-12 col-md-12 col-12">
              <app-custom-textarea formControlName="icaInvoiceObservation" [labelText]="'Observación Factura ICA'"
                [autoResize]="false" [rows]="branchContract.icaInvoiceObservation  ? 3 : 1" [maxLength]="250">
              </app-custom-textarea>
            </div>
            <hr class="my-2">
            <div class="col-lg-12 col-md-12 col-12">
              <b class="label">Configuración de Bodega</b>
              <fieldset class="border p-2">
                <div class="mb-1">
                  <app-custom-checkbox formControlName="swBranchStore" [labelText]="'Asignar bodega predeterminada'">
                  </app-custom-checkbox>
                </div>
                <div class="mb-1" [hidden]="!formBranch.get('swBranchStore')?.value">
                  <app-custom-select formControlName="storeId" [labelText]="'Bodega'" [list]="listStore">
                  </app-custom-select>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <hr class="my-2">
        <b class="label">Cotizaciones</b>
        <div class="col-lg-6 col-md-12 col-12">
          <app-custom-textarea formControlName="quotationObservation" [labelText]="'Observación Cotización'"
            [autoResize]="false" [rows]="branchContract.quotationObservation  ? 3 : 1">
          </app-custom-textarea>
        </div>
        <div class="col-lg-6 col-md-12 col-12">
          <app-custom-textarea formControlName="particularConditionRental" [labelText]="'Condición particular Alquiler'"
            [autoResize]="false" [rows]="branchContract.particularConditionRental  ? 3 : 1"></app-custom-textarea>
        </div>
        <div class="col-lg-6 col-md-12 col-12">
          <app-custom-textarea formControlName="particularConditionSale" [labelText]="'Condición particular Venta'"
            [autoResize]="false" [rows]="branchContract.particularConditionSale  ? 3 : 1">
          </app-custom-textarea>
        </div>
        <div class="col-lg-6 col-md-12 col-12 d-flex align-items-center justify-content-between mt-3 ">
          <app-custom-checkbox formControlName="swAttachConditions" [labelText]="'Adj. Cond. Comerciales'">
          </app-custom-checkbox>
        </div>
        <div class="col-lg-6 col-md-12 col-12 d-flex gap-2 mt-2" *ngIf="branchContract.swAttachConditions">
          <app-custom-button [title]="'Condiciones Alquiler'" [label]="'Condiciones Alquiler'"
            [icon]="'pi pi-paperclip'" [severity]="'contrast'" [width]="'10.5rem'"
            (onClick)="openAttachFile(true)"></app-custom-button>
          <app-custom-modal #attachFile [header]="nameComponent" [children]="componentAttachFiles" [closable]="true"
            [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
            hidden></app-custom-modal>

          <app-custom-button [title]="'Condiciones Venta'" [label]="'Condiciones Venta'" [icon]="'pi pi-paperclip'"
            [severity]="'contrast'" [width]="'10.5rem'" (onClick)="openAttachFile(false)"></app-custom-button>
        </div>
      </div>
    </form>
    <div class="col-lg-12 col-md-12 col-12">
      <div class="row">
        <div class="col field-buttons">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
            [disabled]="disabledForm" (onClick)="send()">
          </app-custom-button>
        </div>
      </div>
    </div>
  </div>
</section>